import type { Icon as PhosphorIcon } from '@phosphor-icons/react';
import styles from './RowTile.module.css';

/**
 * Tile de icono coloreado para las filas de las listas: cuadrado redondeado
 * con fondo en tinte suave (`bg`) e icono Phosphor duotone en `accent`.
 * El icono escala con el tamaño del tile.
 */
interface RowTileProps {
  icon: PhosphorIcon;
  accent: string;
  bg: string;
  /** Lado del tile en px (default 32). */
  size?: number;
}

export function RowTile({ icon: Icon, accent, bg, size = 32 }: RowTileProps) {
  return (
    <span
      className={styles.tile}
      style={{ background: bg, color: accent, width: size, height: size }}
      aria-hidden="true"
    >
      <Icon weight="duotone" size={Math.round(size * 0.55)} />
    </span>
  );
}
